<template>
  <div class="row">

    <div class="col-md-4">
      <div class="card">
        <div class="card-header bg-navyblue">
          <strong>Invoice To</strong>
        </div>
        <div class="card-block bg-white">

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Receipt Number</label>
            <div class="col-sm-8 col-8">
              <input type="text" class="form-control" v-model="invoice.receiptNumber" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Invoice Number</label>
            <div class="col-sm-8 col-8">
              <input type="text" class="form-control" v-model="invoice.number" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Invoice Date</label>
            <div class="col-sm-8 col-8">
              <b-form-datepicker
                  id="invoiceDate"
                  class="mb-2"
                  locale="en-GB"
                  :date-format-options="{  day: '2-digit', month: '2-digit', year: 'numeric'}"
                  v-model="invoice.dateInvoice"
                  :disabled="isUserRoleLawyer"
                  readonly
              ></b-form-datepicker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Bill To</label>
            <div class="col-sm-8 col-8">
              <input type="text" class="form-control" v-model="invoice.vehicleOwner" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label">Bill To Address</label>
            <div class="col-sm-8 col-8">
              <textarea class="form-control" rows="3" readonly></textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 col-form-label" readonly>Due Date</label>
            <div class="col-sm-8 col-8">
              <b-form-datepicker
                  id="invoiceDate"
                  class="mb-2"
                  locale="en-GB"
                  :date-format-options="{  day: '2-digit', month: '2-digit', year: 'numeric'}"
                  v-model="invoice.dueDate"
                  :disabled="isUserRoleLawyer"
              ></b-form-datepicker>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card">
        <div class="card-header bg-navyblue">
          <strong style="visibility: hidden">&nbsp;.</strong>
        </div>
        <div class="card-block bg-white">

          <table class="invoice-table">
            <colgroup>
              <col class="col-wide">
              <col class="col-tight">
              <col class="col-tight">
              <col class="col-tight">
            </colgroup>
            <thead>
            <tr>
              <th>Description</th>
              <th></th>
              <th></th>
              <th>Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr class="body">
              <td colspan="3">
                <div style="min-height: 100px; white-space: pre-line">
                  <template v-if="invoice.due > 0">Complete invoice payment - Partial</template>
                  <template v-else>Payment receipt for Invoice {{ invoice.number }}</template>
                </div>
              </td>
              <td>{{ invoice.total | formatMoney }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <th class="bb">Amount Paid</th>
              <td class="bb">{{ invoice.paid | formatMoney }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <th class="bb">Amount Due</th>
              <td class="bb">{{ (invoice.total - invoice.paid) | formatMoney }}</td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import NumberFormatter from "@/components/utility/number-formatter";
import {mapGetters} from "vuex";

export default {
  name: "receipt",
  components: {
    NumberFormatter,
  },
  computed: {
    ...mapGetters({
      isUserRoleLawyer: 'currentUser/isRoleLawyer',
    })
  },
  props: {
    invoice: {
      type: [Object, null],
      default(){
        return {
          id: 0,
          number: '',
          claimNumber: '',
          assessmentId: 0,
          assessmentNumber: '',
          vehicleOwner: '',
          createdOn: '',
          dueDate: '',
          paid: 0,
          due: 0,
          status: '',
          xeroInvoiceNumber: '',
        };
      }
    },
  }
}
</script>

<style scoped>

.invoice-table {
  width: 100%;
}
.invoice-table td,
.invoice-table th {
  padding: 5px;
  height: auto;
  vertical-align: top;
}
.invoice-table .body {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}
.invoice-table tr.body td {
  border-right: 1px solid lightgray;
}
.invoice-table tr td:last-child {
  border-right: none;
}
.invoice-table tr td.bb,
.invoice-table tr th.bb {
  border-bottom: 1px solid lightgray;
}
.invoice-table tr th.bb {
  text-align: right;
}
.invoice-table .col-wide {

}
.invoice-table .col-tight {
  width: 15%;
}

</style>
